// extracted by mini-css-extract-plugin
module.exports = {"variant-page-wrapper":"VariantPage_variant-page-wrapper__35o3S","section-toolbar":"VariantPage_section-toolbar__31bGd"};